jQuery(document).ready(function ($) {
    "use strict";
    /** Session storage time functions **/
    var startTime, time;

    window.onload = function(){
        if( !sessionStorage.getItem('timeVisited') || sessionStorage.getItem('timeVisited') > 2 * 60 * 60 * 1000 )
        {
            resetTimeOnSite();
        }
    }

    window.onbeforeunload = function(){
        updateTime();
    }

    function updateTime()
    {
        sessionStorage.setItem('timeOnSite', (new Date() - new Date(sessionStorage.getItem('timeVisited'))) );
    }

    function resetTimeOnSite()
    {
        sessionStorage.setItem('timeVisited', (new Date()) );
    }

    function getTimeOnSite()
    {
        updateTime();
        return sessionStorage.getItem('timeOnSite') / 1000;
    }

    if( getTimeOnSite() > 1000 )
    {
    	sessionStorage.clear();
    	resetTimeOnSite();
    }

    if(sessionStorage && !sessionStorage.getItem('show-splash')){
    	sessionStorage.setItem('show-splash', 'yes');
    }

    if( sessionStorage && sessionStorage.getItem('show-splash') == "yes" )
    {
        jQuery('.slider').imagesLoaded( function() {
            if(jQuery('.slider').length){
                $(window).scrollTop(0);
            }
            jQuery('.splash-screen').addClass('.splash-screen--visible').fadeIn().delay(3100).fadeOut();
            jQuery('.main-header__logo-link').fadeOut();

            if (jQuery(window).width() > 650) {
                $(window).scrollTop(0);

                jQuery('.splash-screen.splash-screen--visible').delay(3100).fadeOut();
                setTimeout(function(){
                    jQuery('.slider').addClass('splash-hidden');
                    jQuery('.main-header__logo-link').fadeIn();
                }, 4500);
            }
        });

        sessionStorage.setItem('show-splash', 'no');
    } else {
        if (jQuery(window).width() > 650) {

            if(jQuery('.slider').length){
                $(window).scrollTop(0);
            }

            $(window).scrollTop(0);

            setTimeout(function(){
                jQuery('.slider').addClass('splash-hidden');
                // $(document.body).removeClass('hidescroll');
            }, 500);
        }
    }

});
